export default class AsiListTableHeader {

	public text: string;
	public value: string;
	public sortable: boolean;
	public filterable: boolean;
	public align: string | null = null;
	public width: string | null = null;

	constructor(text: string, value: string, sortable: boolean = false, filterable: boolean = false, align: string | null = null, width: string | null = null) {
		this.text = text;
		this.value = value;
		this.sortable = sortable;
		this.filterable = filterable;
		this.align = align;
		this.width = width;
	}

}
